module.exports = __webpack_public_path__ + "img/os_logo_blue_white.9d78d780.png";